import { Component, Fragment, useEffect, useState } from "react";
import { Table } from "reactstrap";
import { getProfile2 } from "../../../actions/ProfileAction";
import { useProfile } from "../../../contexts/ProfileContext";
import { ReactComponent as FavoriteSvg } from "../../../svgs/favorite_24dp_F20D0D.svg";
import { ReactComponent as SubscriptionSvg } from "../../../svgs/notifications_active_24dp_0D79F2.svg";
import { ReactComponent as SearchSvg } from "../../../svgs/find_in_page_24dp_0D79F2.svg";
import { SEARCH_TAB } from "../../../constants";
import { getTitle } from "../../../utils/documentUtils";

const RenderRow = (props) => {
    //TODO: do correctly
    const removeAction = () => {
        alert("Remove");
        props.remove(props.data.type, props.data.id)
    }
    const typeImage = <td key={`${props.rowKey}_image`}>{
        props.data.type === "favorites" ? <FavoriteSvg />
            : props.data.type === "subscriptions" ? <SubscriptionSvg />
                : props.data.type === "searches" ? <SearchSvg />
                    : <img alt={props.data.type} />
    }</td>;
    const document = <td key={`${props.rowKey}_title`} >{props.data.title}</td>
    const actions = <td key={`${props.rowKey}_actions`} >
        <button className="btn btn-primary" onClick={() => props.handleRedirect(props.data.type, props.data.id)}>{props.data.type === "searches" ? "Search" : "To doc"}</button>
        <button className="btn btn-secondary" style={{ margin: '0 5px' }} >Share</button>
        <button className="btn btn-danger" onClick={removeAction} >Delete</button>
    </td>
    return [typeImage, document, actions];

}

const ProfileList = ({ documents, changeDocumentType, changeTab, remove, searchDocuments, showDocument }) => {
    const getDocuments = () => documents == null ? [] : documents;
    const { profile, setProfile } = useProfile()

    useEffect(() => {
        getProfile2().then((response) => {
            setProfile(response);
        });
        if (getDocuments().length === 0) {
            searchDocuments("*", {}, data => {
                console.log("data", data);
            });
        }
    }, []);

    const handleRemove = (type, id) => {
        remove({ type, value: id });
        getProfile2().then((response) => {
            setProfile(response);
        });
    }

    const handleRedirect = (type, id) => {
        if (type === "searches") {
            const parsedTitle = JSON.parse(id)?.criteria;
            changeDocumentType(parsedTitle.docType, parsedTitle.attributes);
            searchDocuments(parsedTitle.docType, parsedTitle.attributes);
            changeTab(SEARCH_TAB);
        } else {
            const doc = getDocuments().filter(d => d.id.value === id)?.[0];
            if (doc == null) return;
            showDocument(doc);
        }
    }

    const getRows = () => {
        if (!profile) return;
        const favorites = profile.favorites.map((fav, index) => {
            const doc = documents.find(d => d.id.value === fav);
            const data = { type: "favorites", id: fav, title: doc ? getTitle(doc) : fav };
            return <tr key={'fav_' + index}><RenderRow rowKey={'fav_' + index} row={index} data={data} handleRedirect={handleRedirect} remove={handleRemove} /></tr>
        });
        const subscriptions = profile.subscriptions.map((sub, index) => {
            const doc = documents.find(d => d.id.value === sub);
            const data = { type: "subscriptions", id: sub, title: doc ? getTitle(doc) : sub };
            return <tr key={'sub_' + index}><RenderRow rowKey={'sub_' + index} row={index} data={data} handleRedirect={handleRedirect} remove={handleRemove} /></tr>
        });

        const searches = profile.searches.map((search, index) => {
            const data = { type: "searches", id: JSON.stringify(search), title: JSON.stringify(search) };
            return <tr key={'ser_' + index}><RenderRow rowKey={'ser_' + index} row={index} data={data} handleRedirect={handleRedirect} remove={handleRemove} /></tr>
        });
        return [...favorites, ...subscriptions, ...searches];
    }

    return (
        <Fragment>
            <h1>Profile List</h1>
            <Table striped hover>
                <thead>
                    <tr>
                        <th>Icon</th>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {getRows()}
                </tbody>
            </Table>
        </Fragment>
    )
}

export default ProfileList;